import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock3, Layers3, LogOut, Shuffle } from "lucide-react";
import { clearActiveGame } from "../../../utils/activeGame";

export default function RoomHeader({
  categoryName,
  roundIndex,
  totalRounds,
  phase,
  remaining,
  onChangeCategoryClick,
}) {
  const navigate = useNavigate();
  const progress =
    totalRounds > 0 ? Math.min((roundIndex / totalRounds) * 100, 100) : 0;

  return (
    <div className="relative overflow-hidden rounded-[28px] border border-sky-100 bg-white text-pixy-ink shadow-[0_24px_70px_rgba(47,157,226,0.16)]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,209,102,0.32),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(95,181,111,0.22),transparent_30%),linear-gradient(135deg,rgba(255,253,245,0.98),rgba(233,247,255,0.94))]" />

      <div className="relative flex flex-col gap-3 p-4 sm:p-4.5 xl:flex-row xl:items-center xl:justify-between">
        <div className="space-y-2">
          <div className="inline-flex items-center rounded-full border border-pixy-blue/20 bg-white/80 px-2.5 py-1 text-[10px] uppercase tracking-[0.22em] text-pixy-blue">
            Salle de jeu
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-slate-500">
              Categorie en cours
            </p>
            <h1 className="mt-1 text-2xl font-semibold tracking-tight text-pixy-ink sm:text-[28px]">
              {categoryName || "Categorie"}
            </h1>
          </div>

          <div className="max-w-xl text-xs leading-5 text-slate-600 sm:text-sm">
            15 images, 20 secondes pour répondre, puis une courte pause avant
            l'image suivante.
          </div>
        </div>

        <div className="grid gap-2.5 sm:grid-cols-2 xl:min-w-[320px]">
          <div className="rounded-[24px] border border-sky-100 bg-white/80 p-3 shadow-sm backdrop-blur">
            <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-pixy-blue">
              <Layers3 className="h-3.5 w-3.5" />
              Progression
            </div>
            <div className="mt-2 text-xl font-semibold text-pixy-ink">
              {roundIndex}/{totalRounds}
            </div>
            <div className="mt-2 h-1.5 rounded-full bg-sky-100">
              <div
                className="h-full rounded-full bg-gradient-to-r from-pixy-green via-pixy-blue to-pixy-yellow"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>

          <div className="rounded-[24px] border border-amber-100 bg-white/80 p-3 shadow-sm backdrop-blur">
            <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.18em] text-amber-600">
              <Clock3 className="h-3.5 w-3.5" />
              Chrono global
            </div>
            <div
              className={`mt-2 text-2xl font-semibold ${
                remaining <= 5 && phase === "question"
                  ? "text-amber-600"
                  : "text-pixy-ink"
              }`}
            >
              {remaining}s
            </div>
            <p className="mt-1.5 text-[11px] leading-4 text-slate-600">
              Surveille le temps avant validation.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2 xl:self-start">
          <button
            type="button"
            onClick={() => { clearActiveGame(); navigate("/"); }}
            className="inline-flex items-center gap-2 rounded-full border border-pixy-blue/20 bg-white px-3.5 py-2 text-xs font-medium text-pixy-blue shadow-sm transition hover:bg-pixy-sky"
          >
            <LogOut className="h-3.5 w-3.5" />
            Quitter la salle
          </button>
          <button
            type="button"
            onClick={onChangeCategoryClick}
            className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-white px-3.5 py-2 text-xs font-medium text-pixy-green shadow-sm transition hover:bg-emerald-50"
          >
            <Shuffle className="h-3.5 w-3.5" />
            Changer de categorie
          </button>
        </div>
      </div>
    </div>
  );
}
